import * as constant from '../constant.js';
export const login = (user) => {
    return {
        type: constant.USER_LOGIN,
        payload: user
    }
};

export const logout = () => {
    return {
        type: constant.USER_LOGOUT,
    }
};


export const openLeftMenu = () => {
    return {
        type: constant.OPEN_LEFT_MENU,
    }
};

export const setRedirectUrl = (url) => {
    return {
        type: constant.SET_REDIRECT_URL,
        payload: url
    }
};

export const closeLeftMenu = () => {
    return {
        type: constant.CLOSE_LEFT_MENU,
    }
};








// WEBPACK FOOTER //
// ./src/actions/index.js